import { useEffect } from 'react';

import { getIsUserAuthorized } from '@telialt/utils/src/SSO/utils';
import { updateOctocomSession } from '@telialt/utils/src/utils/octocomSession';

export const useOctocomSession = () => {
    useEffect(() => {
        updateOctocomSession(getIsUserAuthorized());
    }, []);
};
